import { Component, OnInit, ElementRef } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment  from 'moment';
import { StockService } from 'src/app/services/Stock/stock.service';

@Component({
  selector: 'app-purchase-order',
  templateUrl: './purchase-order.component.html',
  styleUrls: ['./purchase-order.component.css']
})
export class PurchaseOrderComponent implements OnInit {
  NRFQ:"NRFQ";
  constructor(public ElementRef:ElementRef,private stockService:StockService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { }
 

  PurchaseOrderModel = {
    InventoryCategoryID:2,
    QuotationMappingRevisionID:0,
    POID: 0,
    PONumber:'',
    VendorID: 0,
    DeliveryName: '',
    DeliveryAddress: '',
    City: '',
    State: '',
    ZIP: '',
    BillAmount:0,
    Country: '',
    CompanyReference: '',
    VendorReference: '',
    DeliveryTerms: '',
    PaymentTerms:'',
    IsActive: true,
    RequisitionNo: '',
    RequisitionDate: '',
    QuotationRefNo: '',
    DeliveryRequiredDate: '',
    DiscountAmount: 0,
    Attention: '',
    Remarks: '',
    POLocation: '',
    QuotationMappingID: 0,
    POType: "NRFQ",

}
ViewPurchaseOrderModel = {
    POID: 0,
    PONumber: '',
    VendorID: 0,
    DeliveryName: '',
    DeliveryAddress: '',
    City: '',
    State: '',
    ZIP: '',
    BillAmount: 0,
    Country: '',
    CompanyReference: '',
    VendorReference: '',
    IsActive: true,
    VendorName:"",
    PODate:"",
    VendorCode:"",
    VendorPinCode:"",
    VendorAddress:"",
    CountryName:"",
    VendorState:"",
    VendorCity:"",
    MobileNo:"",
    Email:"",
    ContactPersonEmail:"",
    QuotationNo:"",
    
    ContactPersonName:"",
}
ViewItemList = [];
PODetails  (item) {
    this.ViewPurchaseOrderModel.PONumber = item.PONumber;
    this.ViewPurchaseOrderModel.VendorName = item.VendorName;
    this.ViewPurchaseOrderModel.VendorCode = item.VendorCode;
    this.ViewPurchaseOrderModel.DeliveryAddress = item.DeliveryAddress;
    this.ViewPurchaseOrderModel.DeliveryName = item.DeliveryName;
    this.ViewPurchaseOrderModel.PODate = item.PODate;
    this.ViewPurchaseOrderModel.Email = item.Email;
    this.ViewPurchaseOrderModel.MobileNo = item.MobileNo;
    this.ViewPurchaseOrderModel.VendorCity = item.VendorCity;
    this.ViewPurchaseOrderModel.VendorState = item.VendorState;
    this.ViewPurchaseOrderModel.CountryName = item.CountryName;
    this.ViewPurchaseOrderModel.VendorAddress = item.VendorAddress;
    this.ViewPurchaseOrderModel.VendorPinCode = item.VendorPinCode;
    this.ViewPurchaseOrderModel.ContactPersonName = item.ContactPersonName;
    this.ViewPurchaseOrderModel.ContactPersonEmail = item.ContactPersonEmail;
    this.ViewPurchaseOrderModel.QuotationNo = item.QuotationNo;
    this.ViewPurchaseOrderModel.BillAmount = item.BillAmount;
    this.ViewItemList = item.ItemList;
    for (var i = 0; i < this.ViewItemList.length; i++) {
        this.ViewItemList[i].Total = this.ViewItemList[i].Quantity * this.ViewItemList[i].UnitPrice;
    }
}
ClearViewPurchaseOrderModel  () {
    this.ViewPurchaseOrderModel.PONumber = '';
    this.ViewPurchaseOrderModel.VendorName = '';
    this.ViewPurchaseOrderModel.DeliveryAddress = '';
    this.ViewPurchaseOrderModel.DeliveryName = '';
    this.ViewPurchaseOrderModel.PODate = '';
    this.ViewPurchaseOrderModel.City = '';
    this.ViewPurchaseOrderModel.State = '';
    this.ViewPurchaseOrderModel.ZIP = '';
    this.ViewPurchaseOrderModel.Country = '';
    this.ViewPurchaseOrderModel.CompanyReference = '';
    this.ViewPurchaseOrderModel.VendorReference = '';
    this.ViewPurchaseOrderModel.BillAmount = 0;
    this.ViewItemList = [];
}
ItemModel = {
    InventoryCategoryID: 0,
    ItemID: 0,
    UOMID: 0,
    UnitPrice: 0,
    Quantity: 0,
    EquivalentQty: 0,

}
currentPage = 1;
pageSize = 20;
recordCount = 0;
totalPages = 0;
numberOfPages  () {

    this.totalPages = Math.ceil(this.recordCount / this.pageSize);
}

nextPage  () {
    this.currentPage = this.currentPage + 1;

}

pageSizes  () {
    this.currentPage = 1;
    this.recordCount = 0;
    this.totalPages = 0;

}
FilterModel = {
    InventoryCategoryID:0,
    CurrentIndex: 0,
    PageSize: 20,
    PONumber: '',
    FromDate: '',
    ToDate: '',
    IsRivision: 0,
    IsActive: true,
    VendorID: 0,
    POStatusID:0
}
Submitted = false;
ItemList = [];
ItemUpdate = false;
VendorDataList:any;
Clear  () {
    this.PurchaseOrderModel.POID = 0;
    this.PurchaseOrderModel.PONumber = '';
    this.PurchaseOrderModel.VendorID = 0;
    this.PurchaseOrderModel.DeliveryName = '';
    this.PurchaseOrderModel.DeliveryAddress = '';
    this.PurchaseOrderModel.City = '';
    this.PurchaseOrderModel.State = '';
    this.PurchaseOrderModel.ZIP = '';
    this.PurchaseOrderModel.Country = '';
    this.PurchaseOrderModel.CompanyReference = '';
    this.PurchaseOrderModel.VendorReference = '';
    this.PurchaseOrderModel.IsActive = true;
    this.Submitted = false;
    this.ClearItem();
    this.ItemList = [];
    this.ItemUpdate = false;
    this.PurchaseOrderModel.BillAmount = 0;
    this.PurchaseOrderModel.PaymentTerms = '';
    this.PurchaseOrderModel.RequisitionNo = '';
    this.PurchaseOrderModel.RequisitionDate = '';
    this.PurchaseOrderModel.QuotationRefNo = '';
    this.PurchaseOrderModel.DeliveryRequiredDate = '';
    this.PurchaseOrderModel.DiscountAmount = 0;
    this.PurchaseOrderModel.Attention = '';
    this.PurchaseOrderModel.Remarks = '';
    this.PurchaseOrderModel.QuotationMappingID = 0;
    this.PurchaseOrderModel.DeliveryTerms = '';
    this.VendorDataList = [];
    this.PurchaseOrderModel.QuotationMappingRevisionID = 0;
    this.IsQuotation = false;
}
IsQuotation = false;

TempItemData = [];
EditItem  (item) {
    this.TempItemData = item;
    this.ItemModel.UnitPrice = item.UnitPrice;
    this.ItemModel.Quantity = item.Quantity;
    this.ItemModel.InventoryCategoryID = item.InventoryCategoryID;
    this.BindInventoryItem();
    this.ItemModel.ItemID = item.ItemID;
    this.ItemModel.UOMID = item.UOMID;
    this.ItemModel.EquivalentQty = item.EquivalentQty;
    this.ItemUpdate = true;
};

Add  () {
    if (this.ItemValidation() && this.SingleItemValidation()) {
        var item = {
            ItemID: this.ItemModel.ItemID,
            ItemName: this.GetItemName(this.ItemModel.ItemID),
            Quantity: this.ItemModel.Quantity,
            InventoryCategoryID: this.ItemModel.InventoryCategoryID,
            CategoryName:this.GetInventoryCategoryName(this.ItemModel.InventoryCategoryID),
            UOMID: this.ItemModel.UOMID,
            UOM: this.GetUOMName(this.ItemModel.UOMID),
            UnitPrice: this.ItemModel.UnitPrice,
            Total: this.ItemModel.UnitPrice * this.ItemModel.Quantity,
            EquivalentQty: this.ItemModel.EquivalentQty
        };
        this.ClearItem();
        this.PurchaseOrderModel.InventoryCategoryID = this.ItemModel.InventoryCategoryID;
        this.ItemList.push(item);
        this.GetTotalAmount();
    }
};

GetVendorDataForPO  (VendorID) {
    this.VendorDataList =[];
    this.spinnerService.show();
    this.stockService.GetAllVendor(VendorID).subscribe( (response)=> {
        this.VendorDataList = response.VendorList[0];
         this.spinnerService.hide();
    });
}

GetTotalAmount  () {
    this.PurchaseOrderModel.BillAmount = 0;
    for (var i = 0; i < this.ItemList.length; i++) {
        this.PurchaseOrderModel.BillAmount = this.PurchaseOrderModel.BillAmount + this.ItemList[i].UnitPrice * this.ItemList[i].Quantity;
        this.ItemList[i].Total = this.ItemList[i].UnitPrice * this.ItemList[i].Quantity;
    }
};

removeRow  (index) {
    this.ItemList.splice(index, 1);
    this.GetTotalAmount();
};

ClearItem  () {
    this.ItemModel.UnitPrice = 0;
    this.ItemModel.Quantity = 0;
    this.ItemModel.UOMID = 0;
   //-- this.ItemModel.InventoryCategoryID = 0;
    this.ItemModel.ItemID = 0;
    this.ItemModel.EquivalentQty = 0;
}

Update  () {
    
    this.ItemUpdate = false;
    this.ClearItem();
    this.GetTotalAmount();
};
isupdate = false;
Edit  (item) {

    this.PurchaseOrderModel.POID = item.POID;
    this.PurchaseOrderModel.InventoryCategoryID = item.InventoryCategoryID;
    this.ItemModel.InventoryCategoryID= item.InventoryCategoryID;
    this.BindInventoryItem();
    this.isupdate = false;     
    this.PurchaseOrderModel.PONumber = item.PONumber;
    this.PurchaseOrderModel.VendorID = item.VendorID;
    this.GetVendorDataForPO(item.VendorID);
    this.PurchaseOrderModel.DeliveryName = item.DeliveryName;
    this.PurchaseOrderModel.DeliveryAddress = item.DeliveryAddress;
    this.PurchaseOrderModel.City = item.City;
    this.PurchaseOrderModel.State = item.State;
    this.PurchaseOrderModel.ZIP = item.ZIP;
    this.PurchaseOrderModel.Country = item.Country;
    this.PurchaseOrderModel.BillAmount = item.BillAmount;
    this.PurchaseOrderModel.CompanyReference = item.CompanyReference;
    this.PurchaseOrderModel.VendorReference = item.VendorReference;
    this.PurchaseOrderModel.IsActive = item.IsActive;
    this.PurchaseOrderModel.PaymentTerms = item.PaymentTerms;
    this.PurchaseOrderModel.DeliveryTerms = item.DeliveryTerms;
    this.PurchaseOrderModel.RequisitionNo = item.RequisitionNo;
    this.PurchaseOrderModel.RequisitionDate = moment(item.RequisitionDate).format('DD-MMM-YYYY');
    this.PurchaseOrderModel.QuotationRefNo = item.QuotationRefNo;
    // alert(item.DeliveryRequiredDate);  alert(item.QuotationRefNo);alert(item.InventoryCategoryID);
    this.PurchaseOrderModel.DeliveryRequiredDate =moment(item.DeliveryRequiredDate).format('DD-MMM-YYYY') ;
    this.PurchaseOrderModel.DiscountAmount = item.DiscountAmount;
    this.PurchaseOrderModel.Attention = item.Attention;
    this.PurchaseOrderModel.Remarks = item.Remarks;
    var POLocationIDs = item.POLocation != null ? item.POLocation.split(',') : '';
    for (var i = 0; i < this.POLocationList.length; i++) {
        this.POLocationList[i].IsSelect = false;
        for (var j = 0; j < POLocationIDs.length; j++) {
            if (POLocationIDs[j] == this.POLocationList[i].ItemId) {
                this.POLocationList[i].IsSelect = true;
                break;
            }
        }
    }
    this.ItemList = item.ItemList;
    for (var i = 0; i < this.ItemList.length; i++) {
        this.ItemList[i].Total = this.ItemList[i].Quantity * this.ItemList[i].UnitPrice;
    }
    this.isupdate = true;
    
    // $('#OpenPOmodel').click();
}
POLocationList:any;
Cancel  () {
    this.ItemUpdate = false;
    this.ClearItem();
}
UOMList:any;
 GetUOMName(UOMID) {
    for (var i = 0; i < this.UOMList.length; i++) {
        if (this.UOMList[i].ItemId == UOMID)
            return this.UOMList[i].ItemName;
    }
};
InventoryCategoryList:any;
 GetInventoryCategoryName(InventoryCategoryID) {
    for (var i = 0; i < this.InventoryCategoryList.length; i++) {
        if (this.InventoryCategoryList[i].ItemId == InventoryCategoryID)
            return this.InventoryCategoryList[i].ItemName;
    }
};
InventoryItemList:any;
 GetItemName(ItemID) {
    for (var i = 0; i < this.InventoryItemList.length; i++) {
        if (this.InventoryItemList[i].ItemId == ItemID)
            return this.InventoryItemList[i].ItemName;
    }
};

ItemValidation  () {
    if (this.ItemModel.ItemID == 0) {
        alert("Please  Select  Item");
        return false;
    }
    if (this.ItemModel.InventoryCategoryID == 0) {
        alert("Please  Select  Inventory Category");
        return false;
    }
    if (this.ItemModel.UOMID == 0) {
        alert("Please  Select  UOM.");
        return false;
    }
    if (this.ItemModel.EquivalentQty == 0) {
        alert("Please  Enter  EquivalentQty.");
        return false;
    }
    if ( this.ItemModel.Quantity == 0) {
        alert("Please  Enter  Quantity.");
        return false;
    }
    
    if ( this.ItemModel.UnitPrice == 0) {
        alert("Please  Enter  UnitPrice.");
        return false;
    }
    return true;

}

SingleItemValidation  () {
    for (var i = 0; i < this.ItemList.length; i++) {
        if (this.ItemList[i].UOMID == this.ItemModel.UOMID && this.ItemList[i].ItemID == this.ItemModel.ItemID && this.ItemList[i].InventoryCategoryID == this.ItemModel.InventoryCategoryID) {
            alert(' Please Chose a Different Item ');
            return false
        }
    }
    return true;
}
VendorList:any;
GetAllVendor  () {
     this.lookupService.GetLookupsList('Vendor', '').subscribe( (data)=> {
        this.VendorList = data.LookupItems;
    });
}

//this.GetAllQuotation  () {
//     this.lookupService.GetLookupsList('GetAllQuotation', '').subscribe( (data)=> {
//        this.QuotationList = data.LookupItems;
//    });
//}

GetAllPOLocation  () {
     this.lookupService.GetLookupsList('POLocation', '').subscribe( (data)=> {
        this.POLocationList = data.LookupItems;
        this.POLocationList.splice(0,1);
    });
}

GetInventoryCategory  () {
     this.lookupService.GetLookupsList('StockInventoryCategory', '').subscribe( (data)=> {
        this.InventoryCategoryList = data.LookupItems;
    });
};

POStatusList = [];
GetPOStatus  () {
     this.lookupService.GetLookupsList('POStatus', '').subscribe( (data)=> {
        this.POStatusList = data.LookupItems;
    });
};

GetUOM  () {
     this.lookupService.GetLookupsList('UOM', '').subscribe( (data)=> {
        this.UOMList = data.LookupItems;
    });
};

BindInventoryItem  () {
    var item = {
        ItemId: this.ItemModel.InventoryCategoryID
    }
     this.lookupService.GetLookupsList('StockInventoryItem', JSON.stringify(item)).subscribe( (data)=> {
        this.InventoryItemList = data.LookupItems;
    });
}

 ValidateDropdown() {
    return this.PurchaseOrderModel.VendorID == 0 ;
};

SavePurchaseOrder  (valid) {
  
    this.Submitted = true;

    if (this.ItemList.length == 0) {
        alert("Please Select At Least One Item. ");
        return false;
    }
    var POLocationIDs = '';
    var POLocationList = this.POLocationList;
    for (var i = 0; i < POLocationList.length; i++) {
        if (POLocationList[i].IsSelect && POLocationIDs == '') {
            POLocationIDs = POLocationList[i].ItemId;
        }
        else if (POLocationList[i].IsSelect) {
            POLocationIDs = POLocationIDs + "," + POLocationList[i].ItemId;
        }
    }

    this.PurchaseOrderModel.POLocation = POLocationIDs;
 
    if (valid && !this.ValidateDropdown()) {
        this.PurchaseOrderModel.RequisitionDate=this.PurchaseOrderModel.RequisitionDate=="" &&  this.PurchaseOrderModel.RequisitionDate==null?"":moment(this.PurchaseOrderModel.RequisitionDate).format('DD-MMM-YYYY')
        this.PurchaseOrderModel.DeliveryRequiredDate=this.PurchaseOrderModel.DeliveryRequiredDate=="" &&  this.PurchaseOrderModel.DeliveryRequiredDate==null?"":moment(this.PurchaseOrderModel.DeliveryRequiredDate).format('DD-MMM-YYYY')
      this.spinnerService.show();
        this.PurchaseOrderModel.InventoryCategoryID = this.ItemModel.InventoryCategoryID;
        this.stockService.SavePurchaseOrder(JSON.stringify(this.PurchaseOrderModel), JSON.stringify(this.ItemList)).subscribe( (data)=> {
            if (data.webResponse.Status) {
               
                this.globalHelper.CheckActionStatus(data);
                this.GetAllPurchaseOrder();
                //this.GetAllQuotation();
                this.Clear();
                // $('#Button3').click()
            }
            
                 this.spinnerService.hide();
             
        });
    }
}

SearchAllPO  () {        
    this.GetAllPurchaseOrder();       
}

PrintPO  (item) {
    var url = "printpurchaseorder?POID="+item.POID+"&IsActive="+item.IsActive;
    this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
}

ClearSearch  () {
    this.FilterModel.PONumber = '';
    this.FilterModel.FromDate = '';
    this.FilterModel.ToDate = '';
    this.FilterModel.VendorID = 0;
    this.FilterModel.POStatusID = 0;
}
POList:any;
GetAllPurchaseOrder  () {
   
    this.FilterModel.CurrentIndex = this.currentPage;
    this.FilterModel.PageSize = this.pageSize;
    this.FilterModel.IsRivision = 0;
    this.spinnerService.show();
    this.FilterModel.FromDate=this.FilterModel.FromDate=="" ||  this.FilterModel.FromDate==null?"":moment(this.FilterModel.FromDate).format('DD-MMM-YYYY');
    this.FilterModel.ToDate=this.FilterModel.ToDate=="" || this.FilterModel.ToDate==null?"":moment(this.FilterModel.ToDate).format('DD-MMM-YYYY');
    this.stockService.GetAllPurchaseOrder(JSON.stringify(this.FilterModel)).subscribe( (data)=> {
        this.POList = data.POList;
        this.recordCount = 0;
        if (this.POList != null && this.POList.length > 0) {
            this.recordCount = this.POList[0].RecordCount;
        }
        setTimeout( () =>{
             this.spinnerService.hide();
           
        }, 10);
        this.numberOfPages();
    });
};
RivisionList = [];
PORivisionHistory  (item) {
    this.FilterModel.IsRivision = 1;
    this.FilterModel.PONumber = item.PONumber;
    this.spinnerService.show();
    this.stockService.GetAllPurchaseOrder(JSON.stringify(this.FilterModel)).subscribe( (data)=> {
        this.RivisionList = data.POList;
         this.spinnerService.hide();
    });
}
ClearRivisionHistory  () {
    this.RivisionList = [];
    this.FilterModel.PONumber = '';
}
GetStatus  (IsActive) {
    return IsActive ? 'Yes' : 'No';
};


  ngOnInit() {
    this.GetAllVendor();
    this.GetAllPOLocation();
    this.GetInventoryCategory();
    this.GetUOM();
    this.GetAllPurchaseOrder();
    this.GetPOStatus();
  }

}
